import { useContractSignatureTransientState } from '@/modules/onboarding/hooks/useContractSignatureTransientState';
import * as Sentry from '@sentry/react';
import { useQueryClient } from '@tanstack/react-query';
import { getRouteApi } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useUserLogout } from '../hooks/useAuth';

const routeApi = getRouteApi('/logout');

export function LogoutPage() {
  const { mutateAsync: logout } = useUserLogout();
  const navigate = routeApi.useNavigate();
  const queryClient = useQueryClient();
  const { clearContractTransientState } = useContractSignatureTransientState();

  useEffect(() => {
    (async () => {
      try {
        await logout().then(() => {
          queryClient.clear();
          clearContractTransientState();
        });
      } finally {
        Sentry.setUser(null);

        navigate({
          to: '/login',
        });
      }
    })();
  }, [logout, navigate, queryClient, clearContractTransientState]);

  return <div>Logging out...</div>;
}
